import type { QuickSearchView } from '@/components/QuickSearch/quickSearchRoutes'
import type { QuickSearchCategoryName, QuickSearchCategoryPage, QuickSearchResult } from '@/types/searchTypes'
import { useMemo } from 'react'
import { useQuickSearch, useQuickSearchCategoryInfinite } from '@/hooks/useQuickSearch'

function flattenCategoryPages(pages: QuickSearchCategoryPage[]): QuickSearchResult[] {
  const results: QuickSearchResult[] = []
  for (const page of pages) {
    results.push(...page.results)
  }
  return results
}

export function useQuickSearchResultsPageData(query: string, season: string, selectedView: QuickSearchView) {
  const isAllView = selectedView === 'all'
  const selectedCategory: QuickSearchCategoryName = selectedView === 'all' ? 'subdepartments' : selectedView

  const quickSearch = useQuickSearch(query, season, { enabled: isAllView })
  const categorySearch = useQuickSearchCategoryInfinite(query, season, selectedCategory, { enabled: !isAllView })
  const categoryPages = categorySearch.pages
  const categoryData = useMemo(() => categoryPages[0]
    ? {
        ...categoryPages[0],
        results: flattenCategoryPages(categoryPages),
      } as QuickSearchCategoryPage
    : undefined, [categoryPages])
  const allCategoryResults = quickSearch.data

  return {
    allCategoryResults,
    categoryData,
    categorySearch,
    hasResultsData: isAllView ? !!allCategoryResults : !!categoryData,
    isAllView,
    isError: isAllView ? quickSearch.isError : categorySearch.isError && !categoryData,
    isLoading: isAllView ? quickSearch.isLoading : categorySearch.isLoading,
    isRefetchError: !isAllView && !!categoryData && categorySearch.isError && !categorySearch.isFetchNextPageError,
    refetch: isAllView ? quickSearch.refetch : categorySearch.refetch,
    selectedCategory,
  }
}
